const STW_MY_WAREHOUSE_LOCAL_STORAGE_KEY = "stwMyWarehouse";
const STW_POSTAL_CODE_LOCAL_STORAGE_KEY = "stwPostalCode";
export {
  STW_MY_WAREHOUSE_LOCAL_STORAGE_KEY,
  STW_POSTAL_CODE_LOCAL_STORAGE_KEY
};
